import React from 'react';
import {
  Palette,
  Type,
  Grid3X3,
  MousePointer,
  FileText,
  CreditCard,
  Table,
  Zap,
  Navigation,
  Eye,
  BarChart3,
  Tag,
  AlertTriangle,
} from 'lucide-react';

interface NavigationItem {
  id: string;
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const navigationItems: NavigationItem[] = [
  { id: 'colors', label: 'Colors', icon: Palette },
  { id: 'typography', label: 'Typography', icon: Type },
  { id: 'spacing-layout', label: 'Spacing & Layout', icon: Grid3X3 },
  { id: 'buttons', label: 'Buttons', icon: MousePointer },
  { id: 'form-elements', label: 'Form Elements', icon: FileText },
  { id: 'cards', label: 'Cards', icon: CreditCard },
  { id: 'tables', label: 'Tables', icon: Table },
  { id: 'feedback', label: 'Feedback', icon: Zap },
  { id: 'navigation', label: 'Navigation', icon: Navigation },
  { id: 'progress', label: 'Progress', icon: BarChart3 },
  { id: 'badges', label: 'Badges', icon: Tag },
  { id: 'alerts', label: 'Alerts', icon: AlertTriangle },
  { id: 'overlays', label: 'Overlays', icon: Eye },
];

interface DesignSystemNavigationProps {
  activeSection?: string;
  onSectionClick?: (sectionId: string) => void;
}

const DesignSystemNavigation: React.FC<DesignSystemNavigationProps> = ({
  activeSection,
  onSectionClick,
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">Navigation</h2>
      <nav className="space-y-1">
        {navigationItems.map(item => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onSectionClick?.(item.id)}
              className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-md text-left transition-colors ${
                isActive
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon size={16} className="flex-shrink-0" />
              <span className="text-sm font-medium">
                {item.label === 'Spacing & Layout' ? (
                  <>
                    Spacing &<br />
                    Layout
                  </>
                ) : (
                  item.label
                )}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default DesignSystemNavigation;
